import styled, { css } from 'styled-components';
import { transparentize, rem } from 'polished';
import { fontSize, boxShadow, transition } from '../../mixins';
export var CommStyles = function CommStyles() {
  return css(["display:inline-flex;flex-direction:", ";vertical-align:bottom;font-family:", ";", ";text-decoration:underline;border-radius:", ";cursor:pointer;", ";", ";", ";"], function (_ref) {
    var right = _ref.right;
    return right ? 'row-reverse' : 'unset';
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.font.family.primary;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return fontSize(theme.font.size.xs);
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.radius;
  }, transition, colorStyle, standaloneStyle);
};
export var StyledAnchor = styled.a.withConfig({
  displayName: "Linkstyle__StyledAnchor",
  componentId: "sc-124xyde-0"
})(["", ";"], CommStyles);
export var StyledIconSpan = styled.span.withConfig({
  displayName: "Linkstyle__StyledIconSpan",
  componentId: "sc-124xyde-1"
})(["display:inline-flex;", ";svg{color:", ";", ";}"], function (_ref5) {
  var right = _ref5.right;
  return (right ? 'padding-left' : 'padding-right') + ': 4px';
}, function (_ref6) {
  var theme = _ref6.theme,
      tint = _ref6.tint;
  return theme.color[tint];
}, transition);
export function colorStyle(props) {
  var theme = props.theme;
  var tint = props.isOnDarkBg ? 'white' : props.tint;
  var colorMap = {
    black: theme.color.primary,
    primary: theme.color.black,
    error: theme.color.black,
    sapphire: theme.color.black,
    white: theme.color.grey50
  };
  var baseColor = theme.color[tint];
  var stateColor = colorMap[tint];
  return "\n    color: ".concat(baseColor, ";\n    svg {\n      color: ").concat(baseColor, ";\n    }\n    &:hover {\n      text-decoration: none;\n      color: ").concat(stateColor, ";\n      svg {\n        color: ").concat(stateColor, ";\n      }\n    }\n    &:focus {\n      text-decoration: underline;\n      color: ").concat(baseColor, ";\n      svg {\n        color: ").concat(baseColor, ";\n      }\n    }\n    ").concat(boxShadow(baseColor, 'focus'), ";\n    &:active {\n      color: ").concat(stateColor, ";\n      box-shadow : 0 0 0 3px ").concat(transparentize(0.35, props.isOnDarkBg ? baseColor : stateColor), ";\n      text-decoration: none;\n      svg {\n        color: ").concat(stateColor, ";\n      }\n    }\n  ");
}

function standaloneStyle(_ref7) {
  var theme = _ref7.theme,
      standalonelink = _ref7.standalonelink;
  return standalonelink && "\n      padding-top: ".concat(rem('12px'), ";\n      padding-bottom: ").concat(rem('12px'), ";\n      min-height: ").concat(theme.spaces.xxlg, ";\n    ");
}